/* global Swiper */

document.querySelectorAll( '.b-logos-slider.swiper' ).forEach( ( slider ) => {

	const slidesLength = slider.querySelectorAll( '.b-logos-slider__slide' ).length;
	let swipwerBreakpoints = {};
	if ( slidesLength < 1 ) {

		return;

	}

	if ( slidesLength > 3 ) {

		swipwerBreakpoints = {
			578: {
				spaceBetween: 24,
				slidesPerView: 'auto',
				centeredSlides: true,
				loop:true
			},
			768: {
				spaceBetween: 24,
				slidesPerView: 'auto',
				centeredSlides: true,
				loop:true
			},
			1024: {
				slidesPerView: slidesLength > 4 ? 'auto' : 4,
				centeredSlides: slidesLength > 4 ? true : false,
				loop: slidesLength > 6 ? true : false,
				spaceBetween: 32,
			},
			1440: {
				slidesPerView: slidesLength > 4 ? 'auto' : 4,
				centeredSlides: slidesLength > 4 ? true : false,
				loop: slidesLength > 5 ? true : false,
				spaceBetween: 32,
			},
		}

	} else {

		swipwerBreakpoints = {
			578: {
				spaceBetween: 24,
				slidesPerView: 'auto',
				centeredSlides: true,
				loop:true
			},
			768: {
				slidesPerView: 'auto',
				centeredSlides: false,
				loop: false,
				spaceBetween: 80,
			},
			1024: {
				slidesPerView: 'auto',
				centeredSlides: false,
				loop: false,
				spaceBetween: 80,
			},
			1440: {
				slidesPerView: 'auto',
				centeredSlides: false,
				loop: false,
				spaceBetween: 80,
			},
		}

	}

	new Swiper( slider, {
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 2000,
		},
		slidesPerView: 'auto',
		centeredSlides: true,
		centeredSlidesBounds: true,
		spaceBetween: 24,
		centerInsufficientSlides: true,
		slideClass: 'b-logos-slider__slide',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: swipwerBreakpoints,
	} );


} );
